import React, { useEffect } from 'react';
import { Box, Card, Typography, Grid, Divider, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getServicesIaCreditTransactionByIdStore } from 'store/services-ia-credit-transactions/thunks';
import { PageLayout } from 'components/generics/PageLayout';
import { paddingCardsTables } from 'commons/values';
import { formatDateToYmdNumeric } from 'commons/utils';

export const DetailTransaccionesIa = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { transaction_active } = useSelector((state: any) => state.servicesIaCreditTransactions);

  useEffect(() => {
    if (id) {
      dispatch(getServicesIaCreditTransactionByIdStore(id));
    }
  }, [id, dispatch]);

  const handleBack = () => {
    navigate('/manager/plataforma-ia/creditos/transacciones');
  };

  if (!transaction_active) return null;

  return (
    <PageLayout
      title="Detalle de Transacción"
      mainModule="Plataforma IA"
      icon="Visibility"
      actionButtons={
        <Button
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ borderRadius: 2, px: 3, py: 1, fontWeight: 600, textTransform: 'none' }}
        >
          Volver
        </Button>
      }
    >
      <Card
        sx={{
          mt: paddingCardsTables,
          p: 4,
          borderRadius: '12px',
          border: '1px solid #E5E7EB',
          boxShadow: 'none',
        }}
      >
        <Typography variant="h6" sx={{ mb: 3, color: 'primary.main', fontWeight: 600 }}>
          Información de la Transacción
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Cliente
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.subscription?.customer?.label ||
                transaction_active.subscription?.customerId ||
                'No definido'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Suscripción (Plan)
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.subscription?.plan?.name || 'No definido'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Tipo de Transacción
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.transactionType || 'No definido'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Créditos Operados
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.credits}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Balance Anterior
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.balanceBefore}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Balance Posterior
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.balanceAfter}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Referencia (Tipo / ID)
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.referenceType
                ? `${transaction_active.referenceType} - ${transaction_active.referenceId || ''}`
                : 'No aplica'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Fecha de Transacción
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.createdAt
                ? formatDateToYmdNumeric(transaction_active.createdAt)
                : 'No definida'}
            </Typography>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="body2" color="text.secondary">
              Descripción
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 500, mt: 0.5 }}>
              {transaction_active.description || 'Sin descripción'}
            </Typography>
          </Grid>
        </Grid>
      </Card>
    </PageLayout>
  );
};
